// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1FhVq","inputWrap":"styles_inputWrap__2u3wS","input":"styles_input__3LWZI"};